import $ from "jquery";
import Cookies from "js-cookie";

import morningstarFunctions from "./morningstar-functions";

const {
  elementBindings,
  configuration,
  cssConfig,
  getFreshToken,
  getTokenConfig,
  getQueryParam,
  handleMorningStarError,
} = morningstarFunctions;

function init(): void {
  const $morningstarElement = $(".js-morningstar-xray");

  if (!$morningstarElement.length) {
    return;
  }

  const { tokenApiUrl, componentId, namespace, environment } = $morningstarElement[0].dataset;

  function loadScreener(token: string) {
    const settings = {
      angular: elementBindings(componentId),
      configuration: configuration(namespace, environment, {}),
      apiTokens: getTokenConfig(token),
      css: cssConfig,
    };
    const portfolio = {
      totalValue: 10000,
      currencyId: "GBP",
      holdings: [],
      benchmark: {
        type: "Standard",
        holdings: [
          {
            identifier: getQueryParam("bmarkId", "EUCA000507"),
            identifierType: "MSID",
            weight: 100,
          },
        ],
      },
    };

    const idList = getQueryParam("msIds", "F00000LK2L|F00000M0MB|F00000LWSJ").split("|");
    if (idList.length > 0) {
      const weight = 100 / idList.length;
      idList.forEach(function (item) {
        // (item, index)
        portfolio.holdings.push({
          identifier: item,
          identifierType: "MSID",
          weight: weight,
        });
      });
    }
    window["morningstar"].loader
      .load(settings)
      .then(function () {
        // (manifest)
        console.log("Xray component loaded successfully!");
        window["morningstar"].asterix.instanceRegistry.get("ecXray").setParameter("portfolio", portfolio);
      })
      .catch(function (error: any) {
        handleMorningStarError(error, tokenApiUrl, loadScreener);
      });
  }

  const token = Cookies.get("MSToken");
  if (token) {
    loadScreener(token);
  } else {
    getFreshToken(tokenApiUrl, loadScreener);
  }
}

export default { init };
